export default __webpack_public_path__ + "928f1d2675de2d313a956ca44f9e5aed.png";